import style from "../../calculator.module.css";
import { useRef, useContext } from "react";
import { Context } from "../../../../App";
import { ContextCalculatorUser } from "../../../../context/ContextCalculatorUser";
import { TooltipError } from "../../widgets/TooltipError";
import { generateLinkSpreadsheet } from "../../../../utils/calculator/spreadsheet";
function useContinuousChange(onChange, delay = 100) {
  const intervalRef = useRef(null);
  const start = (index, field, valueToIncrement) => {
    intervalRef.current = window.setInterval(() => {
      onChange(index, field, valueToIncrement);
    }, delay);
  };
  const stop = () => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };
  return { start, stop };
}
function Desktop(props) {
  const {
    showCommission,
    setShowCommission,
    profitSurebet,
    budget,
    roundTo,
    roundingEnabled,
    selectedBookmaker,
    setSelectedBookmaker,
    editingValues,
    editingRoundTo,
    setEditingValues,
    valueIsUnacceptable,
  } = ContextCalculatorUser();
  const {
    dataOperation,
    formData,
    typeSurebet,
    calculateSurebet,
    setValueOption,
    increaseField,
    decreaseField,
    handleStakeChange,
    helperInputChance,
    helperInputStake,
    helperInputBackStake,
    helperInputCommission,
    helperInputBudget,
    helperInputRound,
    handleInputEdition,
    isBlockedFieldsCash,
    manageEventInputRoundingEnabled,
  } = props;
  const { statusMode, buttonSpreadsheet } = useContext(Context);
  const indexBookmakerBonus = 0;
  const handleArrowKey = (e, isBlocked, currentValue, update, step = 1) => {
    if (isBlocked) return;
    if (e.key === "ArrowUp") {
      e.preventDefault();
      update(+(currentValue + step).toFixed(2));
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      update(+(currentValue - step).toFixed(2));
    }
  };
  const { start: startFieldInc, stop: stopFieldInc } =
    useContinuousChange(increaseField);
  const { start: startFieldDec, stop: stopFieldDec } =
    useContinuousChange(decreaseField);
  const helperStartFieldIncrement = (index, field, valueToIncrement = 1) => {
    setEditingValues({});
    startFieldInc(index, field, valueToIncrement);
  };
  const helperStartFieldDecrement = (index, field, valueToIncrement = 1) => {
    setEditingValues({});
    startFieldDec(index, field, valueToIncrement);
  };
  return (
    <>
      <div
        className={`card m-3 shadow ${statusMode ? `${style.calculator_bg_dark} ${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_shadow_container_dark_mode}` : ""} `}
        style={{ marginTop: "70px" }}
      >
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 id={style.calculator_title_event} className="m-0">
                {formData["title"]}
              </h5>

              <h6 className="mb-3">{formData["sub_title"]}</h6>
            </div>
            <div className="d-flex flex-column align-items-end">
              {typeSurebet !== "bonus_bookmaker" &&
                typeSurebet !== "risk_free_betting" && (
                  <div>
                    <p
                      id={style.calculator_fs_profit_game}
                      className={`align-self-start ${profitSurebet > 0 ? "text-success" : profitSurebet < 0 ? "text-danger" : statusMode ? `${style.calculator_text_dark_mode}` : ""} m-0`}
                    >
                      {profitSurebet > 0 ? "+" : ""}
                      {profitSurebet.toFixed(2)}%
                    </p>
                  </div>
                )}

              {buttonSpreadsheet === true && (
                <div>
                  <button
                    className={`spreadsheet-btn-add ${!statusMode ? "spreadsheet-btn-bg-light" : ""}`}
                    onClick={() => {
                      generateLinkSpreadsheet(
                        dataOperation,
                        formData,
                        typeSurebet,
                      );
                    }}
                  >
                    <span className="spreadsheet-btn-icon">+</span>
                    Adicionar à <br /> Planilha
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="row px-1 py-3">
            <div className="col-9"></div>
          </div>
          <div
            className={`text-center row ${style.calculator_row} border-bottom ${statusMode ? style.calculator_border_color_dark : ""}`}
          >
            <div className={`${showCommission ? "col-6" : "col-5"} fw-bold`}>
              Mercado
            </div>
            <div className="col-2 fw-bold ">Chance</div>
            <div className="col fw-bold  d-flex justify-content-center">
              Aposta
              <div className={style.calculator_empty_space}></div>
            </div>
            <div className="col fw-bold ">Lucro</div>
          </div>

          {dataOperation.map((operation, index) => {
            let blockPerMode =
              (typeSurebet === "bonus_bookmaker" &&
                indexBookmakerBonus !== index) ||
              (typeSurebet === "risk_free_betting" &&
                indexBookmakerBonus !== index) ||
              (typeSurebet === "locked_value" && index > 1);
            return (
              <div
                className={`row ${style.calculator_row} border-bottom d-flex align-items-center ${statusMode ? style.calculator_border_color_dark : ""}`}
                key={index}
              >
                <div
                  className={`${showCommission ? "col-6" : "col-5"} d-flex align-items-center`}
                >
                  <div className={`${showCommission ? "w-25" : "w-50"}`}>
                    <p
                      className={`d-inline name-bet-home ${showCommission ? "" : "px-4"} m-0 text-decoration-none ${statusMode ? style.calculator_text_dark_mode : ""}`}
                    >
                      {operation.bet_home_name}
                    </p>
                  </div>

                  <div className="w-50 d-flex flex-column justify-content-center px-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <small>
                        <abbr
                          title={operation.info_market_event}
                          className="cursor-help text-decoration-none"
                          data-bs-delay='{"show":150,"hide":0}'
                          data-bs-html="false"
                          data-bs-original-title={operation.info_market_event}
                          data-bs-toggle="tooltip"
                          data-bs-trigger="hover"
                        >
                          {operation.market_event}
                        </abbr>
                      </small>
                    </div>
                  </div>
                  {showCommission === true && (
                    <div className="align-items-center w-25 d-flex position-relative">
                      {operation.commission < -40 && <TooltipError />}
                      <input
                        type="text"
                        className={`odds align-self-center form-control my-1 ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}  ${operation.commission < -40 ? style.calculator_input_value_invalid : ""}`}
                        placeholder="0.00"
                        value={
                          editingValues[`${index}-commission`] !== undefined
                            ? String(
                                editingValues[`${index}-commission`],
                              ).replace(".", ",")
                            : String(operation.commission).replace(".", ",")
                        }
                        onChange={(e) => {
                          helperInputCommission(e, index, operation);
                        }}
                        onKeyDown={(e) =>
                          handleArrowKey(
                            e,
                            false,
                            operation.commission,
                            (val) => {
                              setValueOption(index, "commission", val);
                              handleInputEdition(
                                index,
                                "commission",
                                String(val),
                              );
                            },
                          )
                        }
                        style={{ width: "70px" }}
                      />
                      <div className="d-flex flex-column">
                        <button
                          className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                          onMouseDown={() => {
                            helperStartFieldIncrement(index, "commission");
                          }}
                          onMouseUp={stopFieldInc}
                          onMouseLeave={stopFieldInc}
                        >
                          <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                            <svg
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 28.77 28.77"
                              xmlSpace="preserve"
                              fill="#505050"
                            >
                              <g>
                                <g id="c105_arrow">
                                  <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                                </g>
                                <g id="Capa_1_169_"></g>
                              </g>
                            </svg>
                          </div>
                        </button>
                        <button
                          className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                          onMouseDown={() => {
                            helperStartFieldDecrement(index, "commission");
                          }}
                          onMouseUp={stopFieldDec}
                          onMouseLeave={stopFieldDec}
                        >
                          <div
                            className="w-100 h-100 d-flex justify-conetent-center align-items-center"
                            style={{ rotate: "180deg" }}
                          >
                            <svg
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 28.77 28.77"
                              xmlSpace="preserve"
                              fill="#505050"
                            >
                              <g>
                                <g id="c105_arrow">
                                  <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                                </g>
                                <g id="Capa_1_169_"></g>
                              </g>
                            </svg>
                          </div>
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-2 d-flex justify-content-center align-items-center fs-5 position-relative">
                  {operation.chance < 1 && <TooltipError />}

                  <input
                    type="text"
                    className={`odds align-self-center form-control my-1 ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}  ${operation.chance < 1 ? style.calculator_input_value_invalid : ""}`}
                    placeholder="0.00"
                    disabled={operation.block_chance}
                    value={
                      editingValues[`${index}-chance`] !== undefined
                        ? String(editingValues[`${index}-chance`]).replace(
                            ".",
                            ",",
                          )
                        : String(operation.chance).replace(".", ",")
                    }
                    onChange={(e) => {
                      helperInputChance(e, index, operation);
                    }}
                    onKeyDown={(e) =>
                      handleArrowKey(
                        e,
                        operation.block_chance,
                        operation.chance,
                        (val) => {
                          setValueOption(index, "chance", val);
                          handleInputEdition(index, "chance", String(val));
                        },
                        0.1,
                      )
                    }
                    style={{ width: "70px" }}
                  />
                  <div className="d-flex flex-column">
                    <button
                      className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                      onMouseDown={() => {
                        helperStartFieldIncrement(index, "chance", 0.1);
                      }}
                      onMouseUp={stopFieldInc}
                      onMouseLeave={stopFieldInc}
                      disabled={operation.block_chance}
                    >
                      <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                        <svg
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 28.77 28.77"
                          xmlSpace="preserve"
                          fill="#505050"
                        >
                          <g>
                            <g id="c105_arrow">
                              <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                            </g>
                            <g id="Capa_1_169_"></g>
                          </g>
                        </svg>
                      </div>
                    </button>
                    <button
                      className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                      onMouseDown={() => {
                        helperStartFieldDecrement(index, "chance", 0.1);
                      }}
                      onMouseUp={stopFieldDec}
                      onMouseLeave={stopFieldDec}
                      disabled={operation.block_chance}
                    >
                      <div
                        className="w-100 h-100 d-flex justify-conetent-center align-items-center"
                        style={{ rotate: "180deg" }}
                      >
                        <svg
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 28.77 28.77"
                          xmlSpace="preserve"
                          fill="#505050"
                        >
                          <g>
                            <g id="c105_arrow">
                              <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                            </g>
                            <g id="Capa_1_169_"></g>
                          </g>
                        </svg>
                      </div>
                    </button>
                  </div>
                </div>

                <div className="col d-flex justify-content-center fs-5 d-flex justify-content-center align-items-center position-relative">
                  {((operation.stake < 0 && budget > 0) ||
                    (editingValues[`${index}-stake`] !== undefined &&
                      editingValues[`${index}-stake`].length === 0)) && (
                    <TooltipError />
                  )}
                  <div>
                    <div className="d-flex align-items-center">
                      <input
                        className={`qt_money align-self-center form-control my-1
                                                ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}
                                                ${(operation.stake < 0 && budget > 0) || (editingValues[`${index}-stake`] !== undefined && editingValues[`${index}-stake`].length === 0) ? style.calculator_input_value_invalid : ""}
                                                ${typeSurebet === "bonus_bookmaker" && indexBookmakerBonus === index ? `border border-2  ${style.calculator_border_bonus_surebet}` : ""}
                                                `}
                        type="text"
                        disabled={
                          operation.block_stake ||
                          blockPerMode ||
                          (isBlockedFieldsCash && index !== selectedBookmaker)
                        }
                        value={
                          editingValues[`${index}-stake`] !== undefined
                            ? String(editingValues[`${index}-stake`]).replace(
                                ".",
                                ",",
                              )
                            : String(operation.stake).replace(".", ",")
                        }
                        onChange={(e) => {
                          helperInputStake(e, index, operation);
                        }}
                        onKeyDown={(e) => {
                          handleArrowKey(
                            e,
                            operation.block_stake,
                            operation.stake,
                            (val) => {
                              setValueOption(index, "stake", val);
                              handleInputEdition(index, "stake", String(val));
                            },
                          );
                        }}
                        style={{
                          minWidth: "50px",
                          width: "90px",
                          maxWidth: "140px",
                          padding: "8px",
                          textAlign: "right",
                          resize: "both",
                        }}
                      />

                      <div className="d-flex flex-column align-items-center">
                        <button
                          className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                          onMouseDown={() => {
                            helperStartFieldIncrement(index, "stake");
                          }}
                          onMouseUp={stopFieldInc}
                          onMouseLeave={stopFieldInc}
                          disabled={
                            operation.block_stake ||
                            blockPerMode ||
                            (isBlockedFieldsCash && index !== selectedBookmaker)
                          }
                        >
                          <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                            <svg
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 28.77 28.77"
                              xmlSpace="preserve"
                              fill="#505050"
                            >
                              <g>
                                <g id="c105_arrow">
                                  <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                                </g>
                                <g id="Capa_1_169_"></g>
                              </g>
                            </svg>
                          </div>
                        </button>
                        <button
                          className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                          onMouseDown={() => {
                            helperStartFieldDecrement(index, "stake");
                          }}
                          onMouseUp={stopFieldDec}
                          onMouseLeave={stopFieldDec}
                          disabled={
                            operation.block_stake ||
                            blockPerMode ||
                            (isBlockedFieldsCash && index !== selectedBookmaker)
                          }
                        >
                          <div
                            className="w-100 h-100 d-flex justify-conetent-center align-items-center"
                            style={{ rotate: "180deg" }}
                          >
                            <svg
                              version="1.1"
                              id="Capa_1"
                              xmlns="http://www.w3.org/2000/svg"
                              x="0px"
                              y="0px"
                              viewBox="0 0 28.77 28.77"
                              xmlSpace="preserve"
                              fill="#505050"
                            >
                              <g>
                                <g id="c105_arrow">
                                  <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                                </g>
                                <g id="Capa_1_169_"></g>
                              </g>
                            </svg>
                          </div>
                        </button>
                      </div>
                    </div>
                    {operation.market_event
                      .toLowerCase()
                      .includes("lay (contra)") && (
                      <div className="d-flex flex-column align-items-center position-relative">
                        <small className={style.calculator_fs_micro}>
                          Responsabilidade
                        </small>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className={`qt_money align-self-center form-control my-1
                                                        ${style.calcularto_bg_success}
                                                        ${
                                                          statusMode
                                                            ? `${style.calculator_border_color_dark}
                                                        ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}`
                                                            : ""
                                                        }
                                                        ${operation.backStake < 0 && budget > 0 ? style.calculator_input_value_invalid : ""}        
                                                        ${typeSurebet === "bonus_bookmaker" && indexBookmakerBonus === index ? `border border-2  ${style.calculator_border_bonus_surebet}` : ""}
                                                    `}
                            disabled={
                              operation.block_stake ||
                              blockPerMode ||
                              (isBlockedFieldsCash &&
                                index !== selectedBookmaker)
                            }
                            value={
                              editingValues[`${index}-backStake`] !== undefined
                                ? String(
                                    editingValues[`${index}-backStake`],
                                  ).replace(".", ",")
                                : String(operation.backStake).replace(".", ",")
                            }
                            onChange={(e) => {
                              helperInputBackStake(e, index);
                            }}
                            onKeyDown={(e) =>
                              handleArrowKey(
                                e,
                                operation.block_stake,
                                operation.backStake,
                                (val) => {
                                  setValueOption(index, "backStake", val);
                                  handleInputEdition(
                                    index,
                                    "backStake",
                                    String(val),
                                  );
                                },
                              )
                            }
                            style={{
                              minWidth: "50px",
                              width: "90px",
                              maxWidth: "140px",
                              padding: "8px",
                              textAlign: "right",
                              resize: "both",
                            }}
                          />
                          <div className="d-flex flex-column align-items-center">
                            <button
                              className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                              onMouseDown={() => {
                                helperStartFieldIncrement(index, "backStake");
                              }}
                              onMouseUp={stopFieldInc}
                              onMouseLeave={stopFieldInc}
                              disabled={
                                operation.block_stake ||
                                blockPerMode ||
                                (isBlockedFieldsCash &&
                                  index !== selectedBookmaker)
                              }
                            >
                              <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                                <svg
                                  version="1.1"
                                  id="Capa_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 28.77 28.77"
                                  xmlSpace="preserve"
                                  fill="#505050"
                                >
                                  <g>
                                    <g id="c105_arrow">
                                      <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                                    </g>
                                    <g id="Capa_1_169_"></g>
                                  </g>
                                </svg>
                              </div>
                            </button>
                            <button
                              className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                              onMouseDown={() => {
                                helperStartFieldDecrement(index, "backStake");
                              }}
                              onMouseUp={stopFieldDec}
                              onMouseLeave={stopFieldDec}
                              disabled={
                                operation.block_stake ||
                                blockPerMode ||
                                (isBlockedFieldsCash &&
                                  index !== selectedBookmaker)
                              }
                            >
                              <div
                                className="w-100 h-100 d-flex justify-conetent-center align-items-center"
                                style={{ rotate: "180deg" }}
                              >
                                <svg
                                  version="1.1"
                                  id="Capa_1"
                                  xmlns="http://www.w3.org/2000/svg"
                                  x="0px"
                                  y="0px"
                                  viewBox="0 0 28.77 28.77"
                                  xmlSpace="preserve"
                                  fill="#505050"
                                >
                                  <g>
                                    <g id="c105_arrow">
                                      <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                                    </g>
                                    <g id="Capa_1_169_"></g>
                                  </g>
                                </svg>
                              </div>
                            </button>
                          </div>
                        </div>
                        <small className={style.calculator_fs_micro}>
                          Aposta a favor
                        </small>
                      </div>
                    )}
                  </div>
                  <div className="form-check ms-3 d-flex align-items-center">
                    {typeSurebet !== "bonus_bookmaker" &&
                      typeSurebet !== "risk_free_betting" &&
                      typeSurebet !== "locked_value" &&
                      isBlockedFieldsCash === false && (
                        <input
                          className="form-check-input d-block"
                          type="radio"
                          name="flexRadioDefault"
                          id="checker_first_home_bet"
                          checked={selectedBookmaker === index}
                          onChange={() => {
                            setEditingValues({});
                            setSelectedBookmaker(index);
                            handleStakeChange(index, operation.stake, true);
                          }}
                        />
                      )}
                  </div>
                </div>

                <div className="profit col d-flex justify-content-center fs-5">
                  <p className="m-0">
                    {operation.profit !== undefined
                      ? valueIsUnacceptable === true
                        ? "Erro"
                        : operation.profit.toFixed(2)
                      : "0.00"}
                  </p>
                </div>
              </div>
            );
          })}

          <div className={`row ${style.calculator_row}`}>
            <div className={`${showCommission ? "col-8" : "col-7"}`}></div>
            <div className="col">
              <div className="d-flex justify-content-center align-items-center fs-5 position-relative">
                {budget < 0 && <TooltipError />}
                <input
                  type="text"
                  disabled={
                    typeSurebet === "bonus_bookmaker" ||
                    typeSurebet === "risk_free_betting" ||
                    typeSurebet === "locked_value" ||
                    isBlockedFieldsCash
                  }
                  id="total_value"
                  className={`qt_money align-self-center form-control my-1
                                        ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""}
                                        ${budget < 0 ? style.calculator_input_value_invalid : ""}    
                                    `}
                  placeholder="0.00"
                  style={{
                    minWidth: "50px",
                    width: "90px",
                    maxWidth: "140px",
                    padding: "5px",
                    textAlign: "right",
                    resize: "both",
                  }}
                  value={
                    editingValues[`-999-budget`] !== undefined
                      ? String(editingValues[`-999-budget`]).replace(".", ",")
                      : String(budget).replace(".", ",")
                  }
                  onChange={(e) => {
                    helperInputBudget(e);
                  }}
                  onKeyDown={(e) =>
                    handleArrowKey(e, false, budget, (val) => {
                      setValueOption(-999, "budget", val);
                      handleInputEdition(-999, "budget", String(val));
                    })
                  }
                />
                <div className="d-flex flex-column">
                  <button
                    className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                    onMouseDown={() => {
                      helperStartFieldIncrement(-999, "budget");
                    }}
                    onMouseUp={stopFieldInc}
                    onMouseLeave={stopFieldInc}
                    disabled={
                      typeSurebet === "bonus_bookmaker" ||
                      typeSurebet === "risk_free_betting" ||
                      typeSurebet === "locked_value" ||
                      isBlockedFieldsCash
                    }
                  >
                    <div className="w-100 h-100 d-flex justify-conetent-center align-items-center">
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 28.77 28.77"
                        xmlSpace="preserve"
                        fill="#505050"
                      >
                        <g>
                          <g id="c105_arrow">
                            <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                          </g>
                          <g id="Capa_1_169_"></g>
                        </g>
                      </svg>
                    </div>
                  </button>
                  <button
                    className={`btn p-0 m-0 ${style.calculator_btn_arrow}`}
                    onMouseDown={() => {
                      helperStartFieldDecrement(-999, "budget");
                    }}
                    onMouseUp={stopFieldDec}
                    onMouseLeave={stopFieldDec}
                    disabled={
                      typeSurebet === "bonus_bookmaker" ||
                      typeSurebet === "risk_free_betting" ||
                      typeSurebet === "locked_value" ||
                      isBlockedFieldsCash
                    }
                  >
                    <div
                      className="w-100 h-100 d-flex justify-conetent-center align-items-center"
                      style={{ rotate: "180deg" }}
                    >
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 28.77 28.77"
                        xmlSpace="preserve"
                        fill="#505050"
                      >
                        <g>
                          <g id="c105_arrow">
                            <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447 c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z"></path>
                          </g>
                          <g id="Capa_1_169_"></g>
                        </g>
                      </svg>
                    </div>
                  </button>
                </div>
                <div className="form-check ms-3 d-flex align-items-center">
                  {typeSurebet !== "bonus_bookmaker" &&
                    typeSurebet !== "risk_free_betting" &&
                    typeSurebet !== "locked_value" &&
                    isBlockedFieldsCash === false && (
                      <input
                        className="form-check-input d-block"
                        type="radio"
                        name="flexRadioDefault"
                        id="checker_total"
                        checked={selectedBookmaker === -999}
                        onChange={() => {
                          setEditingValues({});
                          setSelectedBookmaker(-999);
                          calculateSurebet();
                        }}
                      />
                    )}
                </div>
              </div>
            </div>
            <div className="col"></div>
          </div>
          <div
            className={`card shadow-sm p-2 ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode}` : style.calculator_bg_light}`}
            style={{ backgroundColor: statusMode ? "rgb(25, 28, 31)" : "" }}
          >
            <div
              className="form-check d-flex justify-content-start align-items-center"
              style={{ fontSize: "small" }}
            >
              <input
                className="form-check-input me-1 "
                type="checkbox"
                id="flexCheckDefault"
                style={{
                  minHeight: "15px",
                  minWidth: "15px",
                  fontSize: "0.85vw",
                }}
                checked={roundingEnabled}
                onChange={manageEventInputRoundingEnabled}
              />
              <label
                className="form-check-label me-2 fontSizeSmall"
                htmlFor="flexCheckDefault"
              >
                Arredondar aposta até:
              </label>
              <div className="position-relative">
                <div>{roundTo <= 0 && <TooltipError />}</div>
                <div className="input-group " style={{ width: "120px" }}>
                  <input
                    type="text"
                    className={`form-control h-25
                                        ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_text_dark_mode} ${style.calculator_bg_dark}` : ""} 
                                        ${roundTo < 0 ? style.calculator_input_value_invalid : ""}
                                    `}
                    placeholder="0,00"
                    value={
                      editingRoundTo !== undefined
                        ? String(editingRoundTo).replace(".", ",")
                        : String(roundTo).replace(".", ",")
                    }
                    onChange={(e) => {
                      helperInputRound(e);
                    }}
                    disabled={!roundingEnabled}
                  />
                </div>
              </div>
              <div
                className="form-check px-2 d-flex align-items-center"
                style={{ width: "200px" }}
              >
                <input
                  className="form-check-input position-relative m-0"
                  type="checkbox"
                  id="commission-active"
                  checked={showCommission}
                  onChange={() => setShowCommission(!showCommission)}
                  style={{ minHeight: "15px", minWidth: "15px" }}
                />
                <label
                  className="form-check-label p-0 ms-2 text-color-dark-mode"
                  htmlFor="commission-active"
                >
                  Mostrar comissões
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
var Desktop_default = Desktop;
export { Desktop_default as default };
